export default __webpack_public_path__ + "static/media/TopologicalRelations.0e3fc47d.webp";